(() => {
  'use strict';

  const SELECTORS = {
    desktopForm: '#FacetFiltersForm',
    mobileForm: '#FacetFiltersFormMobile',
    sortForm: '#FacetSortForm',
    drawerSortForm: '#FacetSortDrawerForm',
    pillsForm: '#FacetFiltersPillsForm',
    grid: '#ProductGridContainer',
    filters: '#main-collection-filters',
    collection: '#ProductGridContainer .collection',
    remove: 'facet-remove a',
  };

  let requestController = null;
  let debounceTimer = null;
  const responseCache = new Map();

  function serializeForms(forms) {
    const params = new URLSearchParams();

    forms.forEach((form) => {
      if (!form) return;

      new FormData(form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
    });

    return params.toString();
  }

  function getSearchParams(sourceForm) {
    if (sourceForm && sourceForm.matches(SELECTORS.mobileForm)) {
      return serializeForms([sourceForm]);
    }

    return serializeForms([
      document.querySelector(SELECTORS.desktopForm),
      document.querySelector(SELECTORS.sortForm),
      document.querySelector(SELECTORS.drawerSortForm),
      document.querySelector(SELECTORS.pillsForm),
    ]);
  }

  function getSectionId() {
    const filterContainer = document.querySelector(SELECTORS.filters);
    const productGrid = document.querySelector('#product-grid');

    return (
      (filterContainer && filterContainer.dataset.id) ||
      (productGrid && productGrid.dataset.id) ||
      ''
    );
  }

  function setLoading(isLoading) {
    const collection = document.querySelector(SELECTORS.collection);

    if (collection) collection.classList.toggle('loading', isLoading);

    document
      .querySelectorAll('#ProductCount, #ProductCountDesktop')
      .forEach((element) => element.classList.toggle('loading', isLoading));
  }

  function updateHistory(searchParams, replace = false) {
    const url = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`;
    const state = { searchParams };

    if (replace) {
      window.history.replaceState(state, '', url);
    } else {
      window.history.pushState(state, '', url);
    }
  }

  function replaceContent(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsedHTML.querySelector(SELECTORS.grid);
    const currentGrid = document.querySelector(SELECTORS.grid);
    const newFilters = parsedHTML.querySelector(SELECTORS.filters);
    const currentFilters = document.querySelector(SELECTORS.filters);

    if (!newGrid || !currentGrid) {
      throw new Error('Shopify no devolvió ProductGridContainer.');
    }

    currentGrid.innerHTML = newGrid.innerHTML;

    if (newFilters && currentFilters) {
      currentFilters.innerHTML = newFilters.innerHTML;
    }

    document.dispatchEvent(
      new CustomEvent('facets:updated', {
        detail: { html: parsedHTML },
      })
    );
  }

  async function renderPage(searchParams, updateURL = true) {
    const sectionId = getSectionId();
    if (!sectionId) {
      console.error('Filtros AJAX: no se encontró el ID de la sección.');
      return;
    }

    if (requestController) requestController.abort();
    requestController = new AbortController();

    setLoading(true);

    const query = new URLSearchParams(searchParams);
    query.set('section_id', sectionId);
    const requestURL = `${window.location.pathname}?${query.toString()}`;

    try {
      let html = responseCache.get(requestURL);

      if (!html) {
        const response = await fetch(requestURL, {
          signal: requestController.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) {
          throw new Error(`Shopify respondió con estado ${response.status}.`);
        }

        html = await response.text();
        responseCache.set(requestURL, html);
      }

      replaceContent(html);

      if (updateURL) updateHistory(searchParams);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error al actualizar los filtros mediante AJAX:', error);
      }
    } finally {
      setLoading(false);
    }
  }

  function submitForm(form, eventTarget) {
    const isPriceInput =
      eventTarget &&
      eventTarget.matches(
        'input[name*="filter.v.price"], input[name*="filter.p.price"]'
      );

    window.clearTimeout(debounceTimer);

    if (isPriceInput) {
      debounceTimer = window.setTimeout(() => {
        renderPage(getSearchParams(form));
      }, 500);
      return;
    }

    renderPage(getSearchParams(form));
  }

  document.addEventListener('change', (event) => {
    const form = event.target.closest(
      [
        SELECTORS.desktopForm,
        SELECTORS.mobileForm,
        SELECTORS.sortForm,
        SELECTORS.drawerSortForm,
        SELECTORS.pillsForm,
      ].join(', ')
    );

    if (!form) return;
    submitForm(form, event.target);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(
      [
        SELECTORS.desktopForm,
        SELECTORS.mobileForm,
        SELECTORS.sortForm,
        SELECTORS.drawerSortForm,
        SELECTORS.pillsForm,
      ].join(', ')
    );

    if (!form) return;

    event.preventDefault();
    renderPage(getSearchParams(form));
  });

  document.addEventListener('click', (event) => {
    const removeLink = event.target.closest(SELECTORS.remove);
    if (!removeLink) return;

    event.preventDefault();
    const linkURL = new URL(removeLink.href, window.location.origin);
    renderPage(linkURL.searchParams.toString());
  });

  window.addEventListener('popstate', () => {
    renderPage(window.location.search.slice(1), false);
  });
})();